import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from './core/services/menu.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'api-front';
  isMenuOpen$: Observable<boolean>;

  constructor(public router: Router, private menuService: MenuService) {
    this.isMenuOpen$ = this.menuService.menuOpen$;
  }

  isLoginPage(): boolean {
    return this.router.url === '/login';
  }

  toggleMenu() {
    this.menuService.toggleMenu();
  }
}
